import { useState, forwardRef, useImperativeHandle } from "react"

// libraries
import { Popover } from "@mui/material"

// images
import clearFilterImage from "@/assets/img/icons/clear-filter.svg"
import { trans } from "@/_providers/Translation"

function CompactFilterLayout(
  { children, appliedFiltersCount = 0, onClearClick, onApplyClick },
  ref,
) {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  useImperativeHandle(ref, () => ({
    open: (event) => {
      setAnchorEl(event.currentTarget)
    },
  }))

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      className="compact-filter"
    >
      <div className="compact-filter-head">
        <b>
          {trans("random.filters")} <span>{appliedFiltersCount}</span>
        </b>
      </div>
      <div className="compact-filter-body">{children}</div>
      <div className="compact-filter-footer">
        <button className="clear-filter" onClick={onClearClick}>
          <img src={clearFilterImage} alt="clear" />
          {trans("buttons.clearFilters")}
        </button>
        {/* <button className="button-primary" onClick={onApplyClick}>
          Приложи филтрите
        </button> */}
      </div>
    </Popover>
  )
}

export default forwardRef(CompactFilterLayout)
